import { render, staticRenderFns } from "./ActivityType.vue?vue&type=template&id=be16c1f8"
import script from "./ActivityType.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityType.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports